/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Xrisk_TitleInputs */

const en_home_xrisk_title = /** @type {(inputs: Home_Xrisk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We risk <u>human extinction</u>`)
};

/**
* | output |
* | --- |
* | "We risk <u>human extinction</u>" |
*
* @param {Home_Xrisk_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_xrisk_title = /** @type {((inputs?: Home_Xrisk_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Xrisk_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_xrisk_title(inputs)
});